// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
//使用Intersection Observer API构建无限滚动组件
require('intersection-observer');
//引入公共API
import api from './utils/api'
//引入公共方法
import common from './assets/js/common'
//引入vue-wechat-title插件
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle);
//引入swiper轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper/dist/js/swiper.js'
import VConsole from 'vconsole'

// 图片懒加载
import { Lazyload } from "vant";
Vue.use(Lazyload);

Vue.use(VueAwesomeSwiper);
//引入weui框架
import 'weui'
import weui from 'weui.js'
//引入crypto 使用sha1加密
import crypto from 'crypto'
// 路由参数base64加密
import Base64 from './assets/js/base64.js'
Vue.prototype.$Base64 = Base64;

//引入QRCode
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

import QRCode from 'qrcode'
Vue.use(QRCode)

//引入noData公共组件
import noData from "./components/noData";
Vue.component('no-data', noData)

// // 移动端适配
import 'lib-flexible'

Vue.config.productionTip = false
//全局使用weui
Vue.prototype.weui = weui

Vue.prototype.axios = api
//全局使用crypto 配置sha1加密
Vue.prototype.crypto = crypto
//全局使用common公共方法
Vue.prototype.common = common

import global from './components/global' //引用全局常量文件
Vue.prototype.global = global //挂载全局常量文件

import globelPageData from './components/globelPageData' //引用全局常量数据集合文件
Vue.prototype.globelPageData = globelPageData //挂载全局常量文件

//引入vant框架
import Vant from 'vant'
import 'vant/lib/index.css';
Vue.use(Vant);

// 移动端调试工具
// let vConsole = null
// const developer = common.GetQueryString('developer')
// if(developer && developer==='YH_CY'){
// // if(process.env.NODE_ENV != 'production'){
//     vConsole = new VConsole();
// }

// const vConsole = new VConsole();

// 注册全局事件总线 EventBus
Vue.prototype.EventBus = new Vue();

// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
        // 聚焦元素
        el.focus()
    }
})

// 申明忽略标签 - 用于跳转小程序
Vue.config.ignoredElements = [
    'wx-open-launch-app',
    'wx-open-launch-weapp'
]

if (window.location.hostname == "localhost") {
    sessionStorage.setItem("jksc_auth", '1');
    // sessionStorage.setItem("openId", 'oecDOwkmZsVmfRA8LBW-YqbuyMkM');
    // sessionStorage.setItem("openId", 'o_fNnwy3ys0a5UlKn0ylZoOoRQPk'); // web端使用
    // sessionStorage.setItem("openId", 'ohqJ9uCXpg5j7Rmxq7JXbEizp59I'); // FeBro 义幻科技
    sessionStorage.setItem("openId", 'o_fNnwy3ys0a5UlKn0ylZoOoRQPk'); // 曹宁的
    // sessionStorage.setItem("openId", 'ohqJ9uJ7O6zSoRvlmxyBikU_H_YI'); //  圆心
}
//o_fNnwy3ys0a5UlKn0ylZoOoRQPk
/* eslint-disable no-new */
new Vue({

    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>',
    created: function () {
        //每隔20分钟请求一次 防止服务端session过期 20*60*1000
        let that = this;
        setInterval(function () {
            that.axios.post('/index/refresh', {}, (res) => { })
        }, 20 * 60 * 1000)
        console.log(process.env.NODE_ENV)
    },
    store
})


// WEBPACK FOOTER //
// ./src/main.js